import PhoneSimple from './phone';

export const EmailSimple = text => {
  /* eslint-disable */
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  /* eslint-enable */
  return re.test(text);
};

export const EmailSimpleSemiColon = text => {
  const re = /^(|([a-zA-Z0-9_\-[\].]+)@([a-zA-Z0-9_\-[\].]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z0-9_\-[\].]+)@([a-zA-Z0-9_\-[\].]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
  return re.test(text);
};

export const ValidEmailPhone = text => {
  if (PhoneSimple(text)) {
    return 'sms';
  } else if (EmailSimple(text)) {
    return 'email';
  }
  return null;
};
